import * as React from "react";
import {domToReact} from "html-react-parser"
import {Box, Flex, Img} from "@chakra-ui/react";
import CustomButton from "../../common/customButton/customButton";
import Decor from "./images/decor.svg"

export default function CtaBox({box}){
    const ctaHeader = box?.attribs['data-title'] ?? null
    const ctaText = domToReact(box?.children) ?? null
    const ctaImgUrl = box?.attribs['data-img'] ?? null
    const ctaButtonText = box?.attribs['data-button-text'] ?? null
    const ctaButtonLink = box?.attribs['data-button-link'] ?? null
    return (
        <Flex boxShadow={'0 30px 60px rgba(0,0,0,.08)'} bgColor={'white'} p={{base:'1.5rem', mobile:'3rem'}} my={'3rem'} alignItems={'center'} position={'relative'} flexWrap={'wrap'}>
            <Box as={Decor} position={'absolute'} top={'0'} right={'0'} zIndex={0}/>
            <Box w={{base:'100%', lg:ctaImgUrl ? '66.667%' : '100%', xl:ctaImgUrl ? '50%' : '100%'}} textAlign={{base:'center', lg:ctaImgUrl ? 'left' : 'center'}} order={{base:'2', lg:'1'}}>
                <Box as={'h4'} fontSize={'26px'} p={'0 !important'} m={'0 0 1rem 0 !important'}>{ctaHeader}</Box>
                <Box
                    sx={{
                        'a' : {
                            fontWeight:'600 !important',
                            color:'#000 !important',
                        }
                    }}
                >{ctaText}</Box>
                <CustomButton internal={ctaButtonLink} color={'white'} text={ctaButtonText} mb={'1rem'} mx={{base:'auto', lg:ctaImgUrl ? '0' : 'auto'}}/>
            </Box>
            {ctaImgUrl &&
                <Box w={{base:'100%', lg:'33.333%', xl:'50%'}} order={{base:'1', lg:'2'}}>
                    <Img src={ctaImgUrl} alt={ctaHeader} margin={{base:'0 auto', lg:'0 0 0 2rem'}} maxWidth={{base:'70%', lg:'90%', xl:'100%'}}/>
                </Box>
            }
        </Flex>
    )
}